import React, { useState, useEffect } from 'react';
import axios from 'axios';

export default function AuditLog() {
  const [logs, setLogs] = useState([]);
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    axios.get('/api/audit/checkpoints').then(res => setLogs(res.data));
  }, []);

  const filtered = filter === 'all' ? logs : logs.filter(l => l.phase === filter);

  return (
    <div className="min-h-screen bg-gray-900 text-white p-8">
      <h1 className="text-3xl font-bold mb-6">审计回溯 (不易·可回溯)</h1>
      <div className="flex gap-4 mb-6">
        {['all','需求','设计','编码','测试','部署'].map(p => (
          <button key={p} onClick={() => setFilter(p)} className={`px-3 py-1 rounded ${filter===p?'bg-blue-600':'bg-gray-700'}`}>{p}</button>
        ))}
      </div>
      <div className="bg-gray-800 rounded-lg overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-700">
            <tr>
              <th className="p-3">ID</th><th>时间</th><th>阶段</th><th>操作</th><th>五维评审</th><th>交叉评审</th><th>状态</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map(log => (
              <tr key={log.checkpoint_id} className="border-b border-gray-700">
                <td className="p-3">{log.checkpoint_id}</td>
                <td>{new Date(log.timestamp).toLocaleString()}</td>
                <td>{log.phase}</td>
                <td>{log.action}</td>
                <td>{log.five_dim_review}</td>
                <td>{log.cross_review}</td>
                <td><span className={log.status==='pass'?'text-green-400':'text-red-400'}>{log.status}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

